module.exports = __webpack_public_path__ + "static/media/Snivy_gaussian2.d50bf00d.png";